import { useState } from 'react';
import './Register.css';

const areas = ['Valsad City', 'Bulsar', 'Pardi', 'Vapi', 'Umargam', 'Dharampur', 'Kaprada', 'Navsari', 'Bilimora', 'Gandevi', 'Other'];
const activities = ['Cultural Events', 'Blood Donation', 'Medical Camp', 'Food Distribution', 'Tree Plantation', 'Cleanliness Drive', 'Scholarship', 'Other'];

const steps = ['Mandal Info', 'Contact Details', 'Activities', 'Submit'];

export default function Register() {
  const [step, setStep] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    santhaName: '',
    yearEstd: '',
    area: '',
    address: '',
    memberCount: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    whatsapp: '',
    selectedActivities: [],
    description: '',
    panNumber: '',
    agreed: false,
  });

  const update = (field, value) => setForm((f) => ({ ...f, [field]: value }));
  const toggleActivity = (act) => {
    update('selectedActivities',
      form.selectedActivities.includes(act)
        ? form.selectedActivities.filter((a) => a !== act)
        : [...form.selectedActivities, act]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="register-page">
        <div className="page-hero">
          <div className="container">
            <div className="badge">Registration</div>
            <h1>Register Your Mandal</h1>
          </div>
        </div>
        <section>
          <div className="container" style={{ maxWidth: 600, textAlign: 'center' }}>
            <div className="success-card card">
              <div style={{ fontSize: '4rem' }}>🎉</div>
              <h2>Registration Submitted!</h2>
              <p>Thank you for registering <strong>{form.santhaName}</strong>. Our team will review your details and get back to you at <strong>{form.contactEmail}</strong> within 2–3 working days.</p>
              <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginTop: 12 }}>
                🙏 Jai Ganesh — Welcome to the Aarambh family!
              </p>
              <button className="btn-primary" style={{ marginTop: 24 }} onClick={() => { setSubmitted(false); setStep(0); }}>
                Register Another Mandal
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="register-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Join Us</div>
          <h1>Register Your Mandal</h1>
          <p>Get your Ganpati Mahotsav Mandal listed on Aarambh's directory — reach more devotees, receive donations and coordinate activities.</p>
        </div>
      </div>

      <section>
        <div className="container register-layout">
          <div className="register-main">
            {/* Stepper */}
            <div className="stepper">
              {steps.map((s, i) => (
                <div key={s} className={`step${i === step ? ' active' : i < step ? ' done' : ''}`}>
                  <div className="step-circle">{i < step ? '✓' : i + 1}</div>
                  <span className="step-label">{s}</span>
                  {i < steps.length - 1 && <div className="step-line" />}
                </div>
              ))}
            </div>

            <form className="register-form card" onSubmit={handleSubmit}>
              {/* Step 0 */}
              {step === 0 && (
                <div className="form-step">
                  <h2>Mandal Information</h2>
                  <div className="field-group">
                    <label>Mandal Name *</label>
                    <input className="form-input" placeholder="e.g. Shri Siddhivinayak Ganesh Utsav Mandal" value={form.santhaName} onChange={(e) => update('santhaName', e.target.value)} required />
                  </div>
                  <div className="field-row">
                    <div className="field-group">
                      <label>Year Established *</label>
                      <input className="form-input" type="number" placeholder="e.g. 2010" min="1950" max="2025" value={form.yearEstd} onChange={(e) => update('yearEstd', e.target.value)} required />
                    </div>
                    <div className="field-group">
                      <label>Number of Members *</label>
                      <input className="form-input" type="number" placeholder="e.g. 80" min="5" value={form.memberCount} onChange={(e) => update('memberCount', e.target.value)} required />
                    </div>
                  </div>
                  <div className="field-group">
                    <label>Area / Taluka *</label>
                    <select className="form-input" value={form.area} onChange={(e) => update('area', e.target.value)} required>
                      <option value="">Select Area</option>
                      {areas.map((a) => <option key={a}>{a}</option>)}
                    </select>
                  </div>
                  <div className="field-group">
                    <label>Full Address</label>
                    <textarea className="form-input" rows={3} placeholder="Street, landmark, village/city, pincode" value={form.address} onChange={(e) => update('address', e.target.value)} />
                  </div>
                  <div className="step-nav">
                    <div />
                    <button type="button" className="btn-primary" onClick={() => setStep(1)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 1 */}
              {step === 1 && (
                <div className="form-step">
                  <h2>Contact Details</h2>
                  <div className="field-group">
                    <label>Primary Contact Name *</label>
                    <input className="form-input" placeholder="Full name of President / Secretary" value={form.contactName} onChange={(e) => update('contactName', e.target.value)} required />
                  </div>
                  <div className="field-row">
                    <div className="field-group">
                      <label>Email Address *</label>
                      <input className="form-input" type="email" placeholder="contact@example.com" value={form.contactEmail} onChange={(e) => update('contactEmail', e.target.value)} required />
                    </div>
                    <div className="field-group">
                      <label>Phone Number *</label>
                      <input className="form-input" type="tel" placeholder="+91 99999 00000" value={form.contactPhone} onChange={(e) => update('contactPhone', e.target.value)} required />
                    </div>
                  </div>
                  <div className="field-group">
                    <label>WhatsApp Group Link (optional)</label>
                    <input className="form-input" placeholder="https://chat.whatsapp.com/..." value={form.whatsapp} onChange={(e) => update('whatsapp', e.target.value)} />
                  </div>
                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(0)}>← Back</button>
                    <button type="button" className="btn-primary" onClick={() => setStep(2)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 2 */}
              {step === 2 && (
                <div className="form-step">
                  <h2>Activities & Description</h2>
                  <div className="field-group">
                    <label>Social Activities Conducted (select all that apply)</label>
                    <div className="activities-grid">
                      {activities.map((act) => (
                        <label key={act} className={`activity-check${form.selectedActivities.includes(act) ? ' checked' : ''}`}>
                          <input type="checkbox" checked={form.selectedActivities.includes(act)} onChange={() => toggleActivity(act)} />
                          {act}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="field-group">
                    <label>About Your Mandal</label>
                    <textarea className="form-input" rows={4} placeholder="Tell us about your mandal — history, achievements, what makes you unique..." value={form.description} onChange={(e) => update('description', e.target.value)} />
                  </div>
                  <div className="field-group">
                    <label>PAN Number (if applicable)</label>
                    <input className="form-input" placeholder="e.g. AAAPL1234C" value={form.panNumber} onChange={(e) => update('panNumber', e.target.value)} />
                  </div>
                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(1)}>← Back</button>
                    <button type="button" className="btn-primary" onClick={() => setStep(3)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 3 */}
              {step === 3 && (
                <div className="form-step">
                  <h2>Review & Submit</h2>
                  <div className="review-grid">
                    <div className="review-item">
                      <span className="review-label">Mandal Name</span>
                      <span className="review-value">{form.santhaName || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Area</span>
                      <span className="review-value">{form.area || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Established</span>
                      <span className="review-value">{form.yearEstd || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Members</span>
                      <span className="review-value">{form.memberCount || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Contact</span>
                      <span className="review-value">{form.contactName} — {form.contactEmail}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Phone</span>
                      <span className="review-value">{form.contactPhone || '—'}</span>
                    </div>
                    <div className="review-item" style={{ gridColumn: '1 / -1' }}>
                      <span className="review-label">Activities</span>
                      <span className="review-value">{form.selectedActivities.join(', ') || 'None selected'}</span>
                    </div>
                  </div>

                  <label className="agree-check">
                    <input type="checkbox" checked={form.agreed} onChange={(e) => update('agreed', e.target.checked)} required />
                    <span>I certify that the information provided is accurate and I agree to Aarambh's terms of registration.</span>
                  </label>

                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(2)}>← Back</button>
                    <button type="submit" className="btn-primary" disabled={!form.agreed}>Submit Registration</button>
                  </div>
                </div>
              )}
            </form>
          </div>

          {/* Side Info */}
          <div className="register-sidebar">
            <div className="benefits-card card">
              <h3>Benefits of Registering</h3>
              <ul className="benefits-list">
                <li>✅ Listed in Valsad's Mandal Directory</li>
                <li>✅ Receive online donations directly</li>
                <li>✅ Co-ordinate with 50+ other mandal</li>
                <li>✅ Promote your events to devotees</li>
                <li>✅ Access volunteer network</li>
                <li>✅ Feature in Aarambh social media</li>
                <li>✅ 100% Free — no charges ever</li>
              </ul>
            </div>
            <div className="register-note card">
              <h3>📋 What you'll need</h3>
              <ul>
                <li>Mandal name and founding year</li>
                <li>Contact person details</li>
                <li>List of activities you conduct</li>
                <li>PAN / registration number (optional)</li>
              </ul>
              <p style={{ fontSize: '0.82rem', color: 'var(--text-light)', marginTop: 12 }}>
                Registration is reviewed and approved within 2–3 working days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
